import React, { ReactNode } from "react";
import Icon from "../Icon";

export interface NoResultsProps {
	className?: string;
	icon?: string;
	iconWeight?: "light" | "regular" | "solid" | "brand" | "duotone" | undefined;
	children?: ReactNode;
}

const NoResults: React.FC<NoResultsProps> = ({ className = "", children, icon, iconWeight = "light" }) => {
	return (
		<div className={`no-results ${className}`}>
			{icon && (
				<>
					<Icon icon={icon} type={iconWeight} classes="fa-3x m-bottom" />
					<br />
				</>
			)}
			<div>{children}</div>
		</div>
	);
};

export default NoResults;
